// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSupplier_navbar__TSzJz","logo":"NavbarSupplier_logo__Gu88L","navLinks":"NavbarSupplier_navLinks__tGhxx","navItem":"NavbarSupplier_navItem__5KnbR"};